// BFF: ○ gap — legacy user.list. The provider directory has no bff/crm module of its own.
export { fetchProviders, providerName } from './ProviderService'
export type { Provider } from './ProviderService'
export { isAdmin, providerCanProvideClinicalCareToPatient } from './roles'
